import { render, staticRenderFns } from "./ProvidersBlocked.vue?vue&type=template&id=5a9eb522&"
import script from "./ProvidersBlocked.vue?vue&type=script&lang=js&"
export * from "./ProvidersBlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports